import { render, staticRenderFns } from "./BsTextField.vue?vue&type=template&id=70127d3c&scoped=true&"
import script from "./BsTextField.vue?vue&type=script&lang=js&"
export * from "./BsTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70127d3c",
  null
  
)

export default component.exports